document.addEventListener('DOMContentLoaded', () => {
  const hasWpformsBlock = document.querySelector('.wpforms-container');

  if (!hasWpformsBlock) return; // ⛔ Stoppe si le bloc n'est pas présent

  document.querySelectorAll('.wpforms-field-medium').forEach((field) => {
    const parent = field.closest('.wpforms-field');
    if (parent) {
      parent.classList.add('is-half');
    }
  });
});